import DummyUser from "assets/img/dpmain.png";
import { obfuscateSensitiveNumbers } from "Data/regx";
import { useAuth } from "provider/AuthContext";
import FlagIcon from "assets/img/icons/flag.png";
import { useSharedSafariContext } from "provider/ShareSafariProvider";

const ReplyComponenet = ({ replie }) => {
  const { isLoggedIn } = useAuth();
  const {  sharedSafariDispatch } = useSharedSafariContext();
  const userImage = replie?.user?.profile_display_image;

  const isValidImage = userImage && userImage.trim() !== "";

  return (
    <div className="blog-comment-container" id={`comment-container-${replie?.id}`} key={replie?.id}>
      <div
        className="blog-comment-text ms-lg-4 ms-2 position-relative w-100 flags_reply"
        style={{ border: "none" }}
      >
        <div className="d-flex gap-2">
          <div className="avatar">
            <a href={`/profile/user/${replie?.user?.user_handle}`}>
              <img
                src={isValidImage ? userImage : DummyUser}
                alt="Reply User"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = DummyUser;
                }}
              />
            </a>
          </div>
          <div className="font-color">
            <a href={`/profile/user/${replie?.user?.user_handle}`}>
              <span className="comment-author">{replie?.display_name}</span>
            </a>
            <span className="comment-date">{replie?.date_time}</span>
            <div className="comment-text">
              <p>{obfuscateSensitiveNumbers(replie?.comment)}</p>
            </div>
          </div>
        </div>
        {isLoggedIn && (
          <div
            className="objec-flgs"
            onClick={() => {
              sharedSafariDispatch({
                type: "SET_SHARED_COMMENT_FOR_FLAG",
                payload: null,
              });
              sharedSafariDispatch({
                type: "SET_SHARED_COMMENT_FOR_FLAG",
                payload: replie,
              });
              sharedSafariDispatch({
                type: "SET_SHARED_SAFARI_REPORT_CONTENT_TOGGLE",
                payload: true,
              });
            }}
          >
            <img src={FlagIcon} alt="Flag" className="flagBtn" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReplyComponenet;
